export enum CopyConfigurationSourceType {
  Gis,
  Bim
}
